import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-stone-200 bg-stone-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
        <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="max-w-xl">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-600 text-white">
                <i className="ri-table-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
              </span>
              <span className="font-heading text-base font-bold text-stone-900">USFansLink</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-stone-500">{t('footer.disclaimer')}</p>
          </div>

          <div className="flex flex-col gap-2 sm:items-end">
            <Link to="/" className="text-sm font-medium text-stone-600 hover:text-stone-900 whitespace-nowrap">
              {t('footer.backHome')}
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-medium text-emerald-700 hover:text-emerald-800 whitespace-nowrap"
            >
              {t('footer.mainSite')}
              <i className="ri-arrow-right-up-line ml-1 w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="mt-8 border-t border-stone-200 pt-5 text-xs text-stone-400">
          © {new Date().getFullYear()} USFansLink. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
}